import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-gray-600 dark:text-gray-400 text-sm"
};
import Loader from "@/presentation/components/Loader.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DashboardLoadingState',
    props: {
        message: {},
        overlay: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "data-testid": "dashboard-loading-state",
                class: _normalizeClass(["flex flex-col items-center justify-center gap-4 p-8", __props.overlay ? 'absolute inset-0 bg-white dark:bg-gray-900 z-10' : '']),
                "aria-live": "polite",
                "aria-busy": "true"
            }, [
                _createVNode(Loader),
                (__props.message)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.message), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
